var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneTopRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29787 5.95187L8.42457 11.3777C8.45252 11.4073 8.47279 11.4432 8.4837 11.4822L10.6361 19.1825C11.0519 20.67 13.0504 20.9288 13.8314 19.5963L22.0139 5.63486C22.6976 4.46818 21.8562 3 20.504 3H4.56989C3.0346 3 2.24347 4.83594 3.29787 5.95187ZM9.28434 10.1036L4.38816 4.92169C4.23754 4.76228 4.35055 4.5 4.56989 4.5H19.3581L9.28434 10.1036ZM10.0211 11.4102L20.2132 5.74079L12.5373 18.8379C12.4257 19.0282 12.1401 18.9912 12.0807 18.7787L10.0211 11.4102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTopRight);
export default __webpack_public_path__ + "static/media/paper-plane-top-right.33153ab824772fec0c97c253cf0b91c9.svg";
export { ForwardRef as ReactComponent };